<template>
    <div class="page-quick-sidebar-wrapper top-menu">
      <div class="page-quick-sidebar  dropdown dropdown-quick-sidebar-toggler">
        <div class="nav-justified">
          <div class="row">
            <div class="col-md-2">
              <a href="javascript:;" class="btn green dropdown-toggle" id="cerrarToggler">Cerrar</a>
            </div>
            <div class="col-md-10 text-center">
                <h3>{{title}} <i class="fa fa-sliders"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h3>
            </div>
          </div>
          <div class="tab-content col-md-12">
            <div class="page-quick-sidebar-chat-users">
              <slot name="body">  </slot>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
export default {
    name:"Sidebar",
    props: ['clase','title'],
}
</script>
<style type="text/css">
    .form .form-bordered .form-group > div {
        padding: 6px !important;
    }
    .md-checkbox label > .box {
        height: 17px !important;
        width: 17px !important;
    }
    #s2id_servicio ul {
        max-height: 100px !important;
        overflow-y: auto !important;
    }
    #s2id_comunidad ul {
        max-height: 100px !important;
        overflow-y: auto !important;
    }
    #s2id_status ul {
        max-height: 100px !important;
        overflow-y: auto !important;
    }
</style>